module.exports = __webpack_public_path__ + "static/media/miley-cyrus-x-magnum.7792430d.png";